import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(255, 248, 245, 0.97);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(139, 111, 94, 0.08);

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    background: linear-gradient(
      180deg,
      rgba(122, 92, 80, 0.95) 0%,
      rgba(107, 79, 62, 0.92) 100%
    );
    border-bottom-color: rgba(255, 255, 255, 0.14);
  }
`;

export const HeaderContent = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0.85rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0.75rem 1rem;
    min-height: 56px;
    align-items: center;
  }
`;

export const Logo = styled(Link)`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primaryDark};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;

  span {
    font-style: italic;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.accent};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 4px;
    border-radius: 4px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.38rem;
    color: ${({ theme }) => theme.colors.white};
    letter-spacing: 0.01em;

    span {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`;

export const LogoIcon = styled.span`
  font-size: 1.3rem;
  display: flex;
  align-items: center;
`;

export const Nav = styled.nav`
  display: none;
  align-items: center;
  gap: 2.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
  }
`;

export const NavLink = styled.a`
  font-size: 0.92rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textLight};
  transition: color ${({ theme }) => theme.transitions.default};
  cursor: pointer;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 1px;
    transition: width ${({ theme }) => theme.transitions.default};
  }

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.primaryDark};

    &::after {
      width: 100%;
    }
  }

  &:focus-visible {
    outline: none;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    gap: 0.55rem;
    align-items: center;
  }
`;

const iconButtonBase = `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  text-decoration: none;
`;

export const IconButtonExternal = styled.a`
  ${iconButtonBase}
  background: ${({ theme }) => theme.colors.secondaryLight};
  color: ${({ theme }) => theme.colors.primaryDark};
  transition: all ${({ theme }) => theme.transitions.default};

  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  svg { font-size: 1.1rem; }

  &.whatsapp {
    background: #25D366;
    color: #FFFFFF;
    &:hover { background: #1fb855; }
    &:focus-visible { outline-color: #25D366; }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 38px;
    height: 38px;
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.14);
  }
`;

export const IconButtonInternal = styled(Link)`
  ${iconButtonBase}
  background: ${({ theme }) => theme.colors.secondaryLight};
  color: ${({ theme }) => theme.colors.primaryDark};
  transition: all ${({ theme }) => theme.transitions.default};

  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  svg { font-size: 1.1rem; }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 38px;
    height: 38px;
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.14);
  }
`;

export const CartButtonWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const CartBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e53e3e;
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(229, 62, 62, 0.4);
  pointer-events: none;
  animation: scaleIn 0.3s ease forwards;
`;

